import { Navigate } from 'react-router-dom'
import { useAuth } from '@/shared/context/AuthContext'
import type { ReactNode } from 'react'

interface Props {
  children: ReactNode
  requireOrg?: boolean
}

export function ProtectedRoute({ children, requireOrg = true }: Props) {
  const { session, loading, org, orgLoading } = useAuth()

  if (loading || (session && orgLoading)) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background">
        <div className="size-5 rounded-full border-2 border-primary border-t-transparent animate-spin" />
      </div>
    )
  }

  if (!session) return <Navigate to="/login" replace />

  if (requireOrg && org?.deleted_at) return <Navigate to="/restore" replace />

  if (requireOrg && !org) return <Navigate to="/onboarding" replace />

  if (!requireOrg && org && !org.deleted_at) return <Navigate to="/dashboard" replace />

  return <>{children}</>
}
